export const adminImpersonationCapabilities = "/admin/impersonation_capabilities";
